import { Container, Table } from "react-bootstrap";
import MainMenu from "../../modules/public/mainMenu/mainMenu";
import { useQuery } from "@tanstack/react-query";
import { getAuthMethod } from "../../modules/helper";
import Laoder from "../../components/loading/Loader";
import jalaliTime from "../../functions/jalaliTime";

function Agents() {
  const { isLoading, data } = useQuery({
    queryKey: ["supervisor-agents"],
    queryFn: () =>
      getAuthMethod("/supervisor/v1/agents").then(res => res.data.result),
    refetchOnWindowFocus: false,
    initialData: [],
  });

  return (
    <MainMenu>
      <Container>
        <h4>لیست نمایندگان</h4>
        <section className="w-100 px-1 overflow-x-auto mt-4">
          <Table className="text-center" striped={true} bordered={true}>
            <thead>
              <tr>
                <th>ردیف</th>
                <th>نام</th>
                <th>کد ملی</th>
                <th>موبایل</th>
                <th>استان</th>
                <th>شهر</th>
                <th>آدرس دفتر</th>
                <th>تاریخ</th>
              </tr>
            </thead>
            <tbody>
              {isLoading === true && (
                <tr>
                  <td colSpan="8">
                    <Laoder />
                  </td>
                </tr>
              )}
              {isLoading === false &&
                data?.map((item, idx) => (
                  <tr key={item.id}>
                    <td>{idx + 1}</td>
                    <td>
                      <span>{item.user.name}</span>
                      <span> {item.user.family}</span>
                    </td>
                    <td>{item.user.nationalCode}</td>
                    <td>{item.user.phone}</td>
                    <td>{item.province.faName}</td>
                    <td>{item.city.faName}</td>
                    <td>{item.address}</td>
                    <td>
                      <span className="enable-n">
                        {jalaliTime(item.created_at).full}
                      </span>
                    </td>
                  </tr>
                ))}
            </tbody>
          </Table>
        </section>
      </Container>
    </MainMenu>
  );
}

export default Agents;
